import React from 'react'
import Slider from 'react-slick'
import { SlArrowRight, SlArrowLeft } from 'react-icons/sl'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import * as S from './styles'

export interface CustomSliderProps {
  children: React.ReactNode
  arrowPosition?: 'center' | 'start' | 'end'
  countSlide?: number
}

export const CustomSlider = ({ children, arrowPosition = 'end', countSlide }: CustomSliderProps) => {
  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    speed: 600,
    autoplaySpeed: 10000,
    fade: true,
    nextArrow: <SlArrowRight color="#FFC000" />,
    prevArrow: <SlArrowLeft color="#FFC000" />,
  }

  return (
    <S.Wrapper arrowPosition={arrowPosition} countSlide={countSlide}>
      <Slider {...settings}>{children}</Slider>
    </S.Wrapper>
  )
}
